export default {
    "questionTitleTemplate": "{no}. {title} {require}",
    "questionErrorLocation":"bottom",
    "completedHtml": "<div style='display: flex; justify-content: center; align-items: center; height: 80vh;'><h3>Stop Details Submitted Successfully</h3></div>",    "pages": [
      {
        "name": "Stop Details",
        "elements": [
          {
            "type": "dropdown",
            "name": "Panchyat",
            "title": "Select Panchyat",
            "isRequired": true,
            "choicesByUrl": {
            "url": 'https://l8olgbtnbj.execute-api.ap-south-1.amazonaws.com/dev/api/vehicles/surveypanchyatmaster?user_id=${this.UserID}',
            "valueName": "_id",
            "titleName": "Local Body Name"
            }
          },
          {
            "type": "text",
            "name": "Name",
            "title": "Enter Name:",
            "isRequired": true,
            "maxLength": 500,
            "validators": [{"type": "regex","text": "Please enter valid name.","regex": "^[a-zA-Z ]*$"}]
          },      
          {
            "type": "text",
            "name": "MobileNo",
            "title": "Mobile Number:",
            "isRequired": true,
            "validators": [
              {
                type: "numeric",
                minValue: 1111111111,
                maxValue: 9999999999,
                "text": "Please enter valid MobileNo"
              },
              
            ],
            "inputType":"tel"
            
          },
          {
            type: "dropdown",
            name: "Type",
            title: "Select Type",
            isRequired: true,
            "choicesByUrl": {
            "url": "https://l8olgbtnbj.execute-api.ap-south-1.amazonaws.com/dev/api/vehicles/surveystoptypemaster",
            "valueName": "_id",
            "titleName": "name"
            }
          },
          {
            type: "dropdown",
            name: "SubType",
            "visibleIf":"{Type} == \"65263e60dacf0910d60b7425\"",
            title: "Select Sub-Type",
            isRequired: true,
            "choicesByUrl": {
            "url": "https://l8olgbtnbj.execute-api.ap-south-1.amazonaws.com/dev/api/vehicles/surveystopsubtypemaster?type=commercial",
            "valueName": "_id",
            "titleName": "name"
            }
          },
          {
            type: "dropdown",
            name: "WasteType",
            title: "Select Waste Type",
            isRequired: true,
            "choicesByUrl": {
            "url": "https://l8olgbtnbj.execute-api.ap-south-1.amazonaws.com/dev/api/vehicles/surveystopsubtypemaster",
            "valueName": "_id",
            "titleName": "name"
            }
          },
  
        ],
        title: "Stop Details",
      },
  
    ],
  }